<script lang="ts">
  import type { DelayBadgeView } from '../lib/delay';

  interface Properties {
    view: DelayBadgeView;
  }

  const { view }: Properties = $props();

  const badgeClass = $derived(`delay-badge ${view.cssClass}`);
</script>

<!-- Renders a formatted delay chip. Callers compute `view` via
     `formatDelay` from src/lib/delay; a `null` view means "no badge",
     handled by the caller (do not render this component). -->
<span class={badgeClass}>{view.text}</span>

<style>
  .delay-badge {
    display: inline-block;
    padding: 1px 6px;
    border-radius: 3px;
    font-size: var(--font-size-xs);
    font-weight: 600;
  }

  .delay-cancelled {
    background: var(--color-accent-red);
    color: #fff;
  }

  .delay-zero {
    background: var(--color-border);
    color: var(--color-fg);
  }

  .delay-positive {
    background: var(--color-warn);
    color: #000;
  }

  .delay-negative {
    background: var(--color-accent-green);
    color: #000;
  }
</style>
